module.exports = __webpack_public_path__ + "img/analytics.f41a7d2c.svg";